export const BPS = 10_000n; // basis points denominator
